import type { ReactElement } from 'react'
import { LazyLastCommCell } from 'app/components/contacts/LazyLastCommCell'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'
import { cn } from 'app/lib/utils'
import type { ContactJson } from 'app/types/entities'

/** The last communication, read per card. Custom lists use the board's pre-fetched map instead. */
export function CommsLazySection({
  contact,
  derived,
}: {
  contact: ContactJson
  derived: ContactCardFacts
}): ReactElement {
  const { inConversation } = derived
  return (
    <div className="mt-1.5 min-w-0">
      {contact.lastCommDate ? (
        <LazyLastCommCell
          contactId={contact.id}
          lastCommDate={contact.lastCommDate}
          lastCommActivityType={contact.lastCommActivityType}
          lastCommActivitySubType={contact.lastCommActivitySubType}
          // oxlint-disable-next-line shadcn/no-arbitrary-values -- moved verbatim under the G7 parity net
          wrapperClassName="flex min-w-0 cursor-[inherit] items-center gap-1.5"
          className={cn(`text-body-xs`, inConversation ? `text-default` : `text-subtle`)}
        />
      ) : (
        <p className="truncate text-body-xs text-minimal">No communication logged</p>
      )}
    </div>
  )
}
